import { registerLocaleData } from '@angular/common';
import localeEnGb from '@angular/common/locales/en-GB';
import localeFr from '@angular/common/locales/fr';
import localeNl from '@angular/common/locales/nl';

import {
    DEFAULT_LANGUAGE,
    DEFAULT_LOCALE,
    LANGUAGE_STORAGE_KEY,
    SUPPORTED_LANGUAGES,
    SUPPORTED_LOCALES,
    SupportedLanguage,
    SupportedLocale,
} from './supported-language';

registerLocaleData(localeEnGb);
registerLocaleData(localeNl);
registerLocaleData(localeFr);

export function getDefaultLanguage(): SupportedLanguage {
    const langFromStorage = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    let lang: SupportedLanguage | null = null;
    if (langFromStorage) {
        lang = getSupportedLanguage(langFromStorage);
    }
    if (!lang) {
        for (const language of navigator.languages) {
            lang = getSupportedLanguage(language);
            if (lang) {
                break;
            }
        }
    }
    if (!lang) {
        lang = DEFAULT_LANGUAGE;
    }
    return lang;
}

export function getBrowserSupportedLanguage() {
    for (const lang of navigator.languages) {
        const supportedLanguage = getSupportedLanguage(lang);
        if (supportedLanguage) {
            return supportedLanguage;
        }
    }
    return DEFAULT_LANGUAGE;
}

export function getSupportedLanguage(
    language: string,
    supportedLanguages = SUPPORTED_LANGUAGES,
): SupportedLanguage | null {
    language = language.replace('_', '-');
    const split = language.split('-');
    for (const lang of supportedLanguages) {
        if (lang.startsWith(language) || split[0] === lang) {
            return lang;
        }
    }
    return null;
}

export function getLocale(lang: string): SupportedLocale {
    const userLocale = lang.replace('_', '-');
    if (SUPPORTED_LOCALES.includes(userLocale as SupportedLocale)) {
        return userLocale as SupportedLocale;
    }
    const language = userLocale.split('-')[0];
    for (const locale of SUPPORTED_LOCALES) {
        if (locale.startsWith(language)) {
            return locale;
        }
    }
    return DEFAULT_LOCALE;
}
